<template>
  <IQOS
    :enabled="is_active"
    :systemDependency="'reserve'"
    :title="$t('reserve.price.title')"
  >
    <div>
      <BaseInput
        class="w-100 mt-16"
        fullWidth
        :unitPlaceholder="currency.symbol"
        type="number"
        :readonly="false"
        v-model.number="reservation_price"
        @blur="onEditFinish"
        v-if="is_active"
      />
      <p
        class="iqos-comment qrw-paragraph-md mt-16"
      >
        {{ $t("reserve.price.input") }}
      </p>
    </div>
    <p class="iqos-comment qrw-paragraph-md mt-16 orange-4-color" v-if="!canEnable">
      {{ $t("reserve.price.setup") }}
    </p>
    <ReservePayReceiver class="mt-16" v-if="is_active" />
    <template #actions>
      <IQOSToggle v-model="is_active" />
    </template>
    <!-- <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" /> -->
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS";
import IQOSActions from "@/components/IQOSActions";
import IQOSToggle from "@/components/IQOSToggle.vue";

import BlackInput from "@/components/BlackInput.vue";

import ReservePayReceiver from "@/components/reserve/ReservePayReceiver.vue";

export default {
  data() {
    return {
      editing: false,
      is_active: false,

      reservation_price: 0,
    };
  },
  watch: {
    is_active() {
      if (!this.is_active) {
        this.reservation_price = 0;
        this.onEditFinish();
      }
    },
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.resetValues();
    },
    onEditFinish() {
      if (this.canEnable) {
        this.$store.commit("setReservePrice", this.reservation_price);
        this.$store.dispatch("saveCafe");
      }

      this.$store.dispatch("auditlog/write", {
        type: "change_reserve_price",
        payload: {
          value: this.reservation_price
        },
      });

      // this.editing = false;
    },
    resetValues() {
      if (this.cafe.reserve) {
        this.reservation_price = this.cafe.reserve.reservation_price || 0;
      }

      this.is_active = this.reservation_price > 0;
    },
  },
  mounted() {
    this.resetValues();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    currency() {
      return this.$store.state.currency;
    },
    canEnable() {
      return !!this.cafe.reserve.pay_receiver_id;
    },
  },
  components: {
    IQOS,
    IQOSActions,
    BlackInput,
    IQOSToggle,
    ReservePayReceiver,
  },
};
</script>

<style scoped>
.price-input {
  width: 100%;
  margin-top: 1vh;
}

.price-input:first-child {
  margin-top: 0;
}
</style>